module.exports = __webpack_public_path__ + "img/resource_download.2db93afa.png";